import { Dialog, DialogContent, DialogTitle, Divider, Grid } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react'; // CHANGED: added useRef
import { Close, SaveOutlined } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { ConsentLogHistoryLayout } from '~/components/BillingEligibility/ConsentLogHistoryLayout';
import axios from 'axios';
import { RpmConsentSection } from "~/components/consent/RpmConsentSection";
import { CcmConsentSection } from "~/components/consent/CcmConsentSection";
import dayjs from 'dayjs';
import { useNavigate } from "react-router";
import { fetchPatientData } from "~/api/patient/fetchPatientData";
import { format } from "date-fns";
import { SyncProgressLayout } from "~/components/patientReports/SyncProgressLayout";
import { SelectPrimaryPatientModal } from "~/components/dashboard/SelectPrimaryPatientModal";
import { CgmConsentSection } from './CgmConsentSection';
const removeOverlay = () => {
    document.querySelectorAll('.overflow-component')?.[0]?.remove();
};
export const ConsentModal = (props) => {
    const { patient, onRequestClose } = props;
    const [isLoading, setIsLoading] = useState(true);
    const [isFeatchProcess, setIsFeatchProcess] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [isMergeModal, setIsMergeModal] = useState(false);
    const [fetchPatientId, setFetchPatientId] = useState(patient.id);
    const [consentLogs, setConsentLogs] = useState([]);
    const [isShowingConsentLogs, setIsShowingConsentLogs] = useState(false);
    const [consentMethod, setConsentMethod] = useState(null);
    const [consentDate, setConsentDate] = useState(null);
    const [consentNotes, setConsentNotes] = useState(null);
    const [optOutReason, setOptOutReason] = useState(null);
    const [optOutDate, setOptOutDate] = useState(null);
    const [optOutNotes, setOptOutNotes] = useState(null);
    const [consentMethodCcm, setConsentMethodCcm] = useState(null);
    const [consentDateCcm, setConsentDateCcm] = useState(null);
    const [consentNotesCcm, setConsentNotesCcm] = useState(null);
    const [optOutReasonCcm, setOptOutReasonCcm] = useState(null);
    const [optOutDateCcm, setOptOutDateCcm] = useState(null);
    const [optOutNotesCcm, setOptOutNotesCcm] = useState(null);
    const [rpmSelection, setRpmSelection] = useState('');
    const [rpmFormData, setRpmFormData] = useState(null);
    const [ccmSelection, setCcmSelection] = useState('');
    const [ccmFormData, setCcmFormData] = useState(null);
    const [cgmSelection, setCgmSelection] = useState(!!patient.cgmConsent); // CHANGED: coerce to boolean
    const [rpmAllRequiredChecked, setRpmAllRequiredChecked] = useState(true); // default true for 'no-consent'
    const [ccmAllRequiredChecked, setCcmAllRequiredChecked] = useState(true);
    const [initialState, setInitialState] = useState(null);
    const initialConsent = patient.rpmConsent || patient.ccmConsent;
    // NEW: always-current mirror of the selections, so handlers never read stale values
    const selectionsRef = useRef({ rpm: '', ccm: '' });
    // Get patient consent logs on first load
    // useEffect with no dependencies
    useEffect(() => {
        getPatientConsentLog();
    }, []);
    const getPatientConsentLog = async () => {
        const response = await axios.post('/api/consent/getPatientConsentLog', { patientId: patient.id });
        if (response.data.data.length > 0) {
            const array = response.data.data;
            const items = [];
            for (const element of array) {
                let notes = '-';
                if (element.consent_notes !== null) {
                    notes = element.consent_notes;
                }
                if (element.opt_out_notes !== null) {
                    notes = element.opt_out_notes;
                }
                const newLog = {
                    dateTime: element.date,
                    action: element.action,
                    userName: element.user_name,
                    consentMethod: element.consent_method,
                    optOutReason: element.opt_out_reason,
                    program: element.program,
                    notes
                };
                items.push(newLog);
            }
            setConsentLogs(items.reverse());
            // Filter logs by program
            const rpmLogs = response.data.data.filter(log => log.program === 'RPM');
            const ccmLogs = response.data.data.filter(log => log.program === 'CCM');
            // Get most recent RPM log
            if (patient.rpmConsent && rpmLogs.length > 0) {
                const mostRecentRpm = rpmLogs[rpmLogs.length - 1];
                setConsentMethod(mostRecentRpm.consent_method);
                setConsentDate(mostRecentRpm.date);
                setConsentNotes(mostRecentRpm.consent_notes);
            }
            else if (!patient.rpmConsent && rpmLogs.length > 0) {
                const mostRecentRpm = rpmLogs[rpmLogs.length - 1];
                setOptOutReason(mostRecentRpm.opt_out_reason);
                setOptOutDate(mostRecentRpm.date);
                setOptOutNotes(mostRecentRpm.opt_out_notes);
            }
            // Get most recent CCM log
            if (patient.ccmConsent && ccmLogs.length > 0) {
                const mostRecentCcm = ccmLogs[ccmLogs.length - 1];
                setConsentMethodCcm(mostRecentCcm.consent_method);
                setConsentDateCcm(mostRecentCcm.date);
                setConsentNotesCcm(mostRecentCcm.consent_notes);
            }
            else if (!patient.ccmConsent && ccmLogs.length > 0) {
                const mostRecentCcm = ccmLogs[ccmLogs.length - 1];
                setOptOutReasonCcm(mostRecentCcm.opt_out_reason);
                setOptOutDateCcm(mostRecentCcm.date);
                setOptOutNotesCcm(mostRecentCcm.opt_out_notes);
            }
        }
        setIsLoading(false);
    };
    useEffect(() => {
        if (!isLoading && initialState === null) {
            const rpmInitialSelection = patient.rpmConsent ? 'opt-in' :
                (patient.rpmConsentedAt !== null && patient.rpmConsentedAt !== '' ? 'opt-out' : 'no-consent');
            const ccmInitialSelection = patient.ccmConsent ? 'opt-in' :
                (patient.ccmConsentedAt !== null && patient.ccmConsentedAt !== '' ? 'opt-out' : 'no-consent');
            setRpmSelection(rpmInitialSelection);
            setCcmSelection(ccmInitialSelection);
            // NEW: seed the ref so the first user change compares against the real initial values
            selectionsRef.current = { rpm: rpmInitialSelection, ccm: ccmInitialSelection };
            setInitialState({
                cgm: {
                    selection: !!patient.cgmConsent // CHANGED: coerce to boolean so hasChanges compares like with like
                },
                rpm: {
                    selection: rpmInitialSelection,
                    consentMethod: consentMethod,
                    consentDate: consentDate ? dayjs(consentDate).format('YYYY-MM-DD HH:mm:ss ZZ') : null,
                    consentNotes: consentNotes,
                    optOutReason: optOutReason,
                    optOutDate: optOutDate ? dayjs(optOutDate).format('YYYY-MM-DD HH:mm:ss ZZ') : null,
                    optOutNotes: optOutNotes
                },
                ccm: {
                    selection: ccmInitialSelection,
                    consentMethod: consentMethodCcm,
                    consentDate: consentDateCcm ? dayjs(consentDateCcm).format('YYYY-MM-DD HH:mm:ss ZZ') : null,
                    consentNotes: consentNotesCcm,
                    optOutReason: optOutReasonCcm,
                    optOutDate: optOutDateCcm ? dayjs(optOutDateCcm).format('YYYY-MM-DD HH:mm:ss ZZ') : null,
                    optOutNotes: optOutNotesCcm
                }
            });
        }
    }, [isLoading, consentMethod, consentDate, consentNotes, optOutReason, optOutDate, optOutNotes,
        consentMethodCcm, consentDateCcm, consentNotesCcm, optOutReasonCcm, optOutDateCcm, optOutNotesCcm]);
    // NEW: single place where the CGM auto-rule runs. Reads/writes selectionsRef so it
    // always sees the latest values even if RPM and CCM callbacks fire back-to-back.
    const applySelectionChange = (program, selection) => {
        const prev = selectionsRef.current[program];
        selectionsRef.current = { ...selectionsRef.current, [program]: selection };
        if (selection === prev)
            return; // callback re-fired with same selection → not a user change, leave CGM alone
        if (selection === 'opt-in') {
            // Rule: opting in to ANY program → CGM active
            setCgmSelection(true);
        }
        else {
            // 'opt-out' or 'no-consent' → CGM inactive, unless the other program is still opted in
            const other = program === 'rpm' ? selectionsRef.current.ccm : selectionsRef.current.rpm;
            if (other !== 'opt-in') {
                setCgmSelection(false);
            }
        }
    };
    const handleRpmDataChange = (selection, formData) => {
        applySelectionChange('rpm', selection); // NEW
        setRpmSelection(selection);
        setRpmFormData(formData);
        if (selection === 'no-consent') {
            setRpmAllRequiredChecked(true);
        }
    };
    const handleCcmDataChange = (selection, formData) => {
        applySelectionChange('ccm', selection); // NEW
        setCcmSelection(selection);
        setCcmFormData(formData);
        // If selection is 'no-consent', no checks required
        if (selection === 'no-consent') {
            setCcmAllRequiredChecked(true);
        }
    };
    const handleRpmRequiredChecks = (allChecked) => {
        setRpmAllRequiredChecked(allChecked);
    };
    const handleCcmRequiredChecks = (allChecked) => {
        setCcmAllRequiredChecked(allChecked);
    };
    // CHANGED: manual override just sets the value; nothing syncs over it anymore
    const handleCgmActiveChanged = (activeState) => {
        setCgmSelection(activeState);
    };
    const hasChanges = () => {
        if (!initialState)
            return false;
        // Check if RPM selection changed
        if (rpmSelection !== initialState.rpm.selection) {
            return true;
        }
        // Check if CCM selection changed
        if (ccmSelection !== initialState.ccm.selection) {
            return true;
        }
        if (cgmSelection !== initialState.cgm.selection) {
            return true;
        }
        return false;
    };
    // Determine if save button should be enabled
    const canSave = rpmAllRequiredChecked && ccmAllRequiredChecked && hasChanges();
    const handleSaveChanges = async () => {
        const submissionData = {
            patientId: patient.id,
            cgm: {
                selection: cgmSelection
            },
            rpm: {
                selection: rpmSelection,
                ...rpmFormData
            },
            ccm: {
                selection: ccmSelection,
                ...ccmFormData
            }
        };
        console.log('Submitting:', submissionData);
        await axios.post('/api/consent/updateConsent', submissionData);
        if (cgmSelection) {
            onSaveOptIn();
        }
        else {
            onSaveOptOut();
        }
    };
    // Fetch functions
    const navigate = useNavigate();
    const handleFetch = useCallback(async () => {
        console.log('our fetch id is: ');
        console.log(fetchPatientId);
        // const patientName = `${patient.personalInfo.firstname} ${patient.personalInfo.lastname}`;
        setIsFeatchProcess(true);
        setIsFetching(true);
        const patientReport = patient.lastReport[0];
        try {
            const { reports } = await fetchPatientData({ patientId: fetchPatientId });
            if (reports.length > 0) {
                const mostRecentReport = reports[0];
                const today = format(new Date(), 'yyyy-MM-dd');
                const reportDate = format(mostRecentReport.createdAt, 'yyyy-MM-dd');
                const isReportUpdated = (today === reportDate && patientReport?.id !== mostRecentReport?.id);
                if (isReportUpdated) {
                    navigate(`/report/${mostRecentReport.id}`);
                }
                else {
                    // toast.success(`Report data for ${patientName} updated. No new reports to show`, {
                    //   type: 'success',
                    //   autoClose: false,
                    // });
                    setIsFetching(false);
                    removeOverlay();
                    onRequestClose();
                }
            }
            else {
                // toast.success(`Report data for ${patientName} updated. No new reports to show`, {
                //   type: 'success',
                //   autoClose: false,
                // });
                setIsFetching(false);
                removeOverlay();
                onRequestClose();
            }
            setIsFeatchProcess(false);
            setIsFetching(false);
        }
        catch (error) {
            console.error('error', error);
            setIsFeatchProcess(false);
            setIsFetching(false);
            removeOverlay();
            // toast.error('Error retrieving patient report', {
            //   type: 'error',
            //   autoClose: false,
            // });
            onRequestClose();
            window.location.reload();
        }
        setIsFeatchProcess(false);
        setIsFetching(false);
        removeOverlay();
        window.location.reload();
    }, [patient]);
    const saveClicked = (selId) => {
        console.log('primary selected: ');
        console.log(selId);
        setFetchPatientId(selId);
        console.log(fetchPatientId);
        setIsFetching(true);
        // addOverlay();
        handleFetchNewPrimary(selId);
    };
    const handleFetchNewPrimary = async (patientId) => {
        if (patient.id !== patientId) {
            await axios.post('/api/patient/makePatientPrimary', {
                patient_id: patientId
            });
        }
        // const patientName = `${patient.personalInfo.firstname} ${patient.personalInfo.lastname}`;
        setIsFeatchProcess(true);
        setIsFetching(true);
        const patientReport = patient.lastReport[0];
        try {
            const { reports } = await fetchPatientData({ patientId });
            if (reports.length > 0) {
                const mostRecentReport = reports[0];
                const today = format(new Date(), 'yyyy-MM-dd');
                const reportDate = format(mostRecentReport.createdAt, 'yyyy-MM-dd');
                const isReportUpdated = (today === reportDate && patientReport?.id !== mostRecentReport?.id);
                if (isReportUpdated) {
                    navigate(`/report/${mostRecentReport.id}`);
                }
                else {
                    // toast.success(`Report data for ${patientName} updated. No new reports to show`, {
                    //   type: 'success',
                    //   autoClose: false,
                    // });
                    setIsFetching(false);
                    removeOverlay();
                    onRequestClose();
                }
            }
            else {
                // toast.success(`Report data for ${patientName} updated. No new reports to show`, {
                //   type: 'success',
                //   autoClose: false,
                // });
                setIsFetching(false);
                removeOverlay();
                onRequestClose();
            }
            setIsFeatchProcess(false);
            setIsFetching(false);
        }
        catch (error) {
            console.error('error', error);
            setIsFeatchProcess(false);
            setIsFetching(false);
            removeOverlay();
            // toast.error('Error retrieving patient report', {
            //   type: 'error',
            //   autoClose: false,
            // });
            onRequestClose();
        }
        setIsFeatchProcess(false);
        setIsFetching(false);
        removeOverlay();
    };
    const onSaveOptIn = async () => {
        console.log('on save');
        if (patient.mergedPatients.length > 0 && !initialConsent) {
            setIsMergeModal(true);
        }
        else {
            setIsFetching(true);
            await handleFetch();
            setIsFetching(false);
            removeOverlay();
            onRequestClose();
        }
    };
    const onSaveOptOut = () => {
        removeOverlay();
        onRequestClose();
        window.location.reload();
    };
    return (React.createElement(React.Fragment, null,
        isFetching && (React.createElement("div", { className: "fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 flex flex-col items-center justify-center", style: { backgroundColor: 'rgba(0, 0, 0, .4)' } },
            React.createElement(SyncProgressLayout, { tryAgainClicked: handleFetch, closeClicked: () => setIsFetching(false), patientId: fetchPatientId }))),
        isFeatchProcess && React.createElement(React.Fragment, null),
        !isLoading && (React.createElement(Dialog, { style: { visibility: isFetching ? 'hidden' : 'visible' }, open: true, PaperProps: {
                sx: {
                    height: '90vh',
                    maxHeight: '90vh',
                    maxWidth: '65%',
                    width: '65%'
                }
            } },
            isMergeModal && (React.createElement(SelectPrimaryPatientModal, { patient: patient, onRequestClose: () => setIsMergeModal(false), mergedPatients: patient.mergedPatients, saveClicked: (patient) => saveClicked(patient) })),
            React.createElement(DialogTitle, { sx: { m: 0, p: 2 }, id: "customized-dialog-title" },
                React.createElement(Grid, { container: true },
                    React.createElement(Grid, { item: true, xs: 9, style: { display: 'flex' } },
                        React.createElement("button", { style: { float: 'left', color: '#00000099' }, onClick: onRequestClose },
                            React.createElement(Close, null)),
                        React.createElement("div", { className: 'block ml-2' },
                            React.createElement("h2", { className: "text-2xl text-black font-bold" }, "Programs"),
                            React.createElement("p", { className: "text-sm font-bold text-app-slate-rhythm" },
                                patient.personalInfo.firstname,
                                " ",
                                patient.personalInfo.lastname,
                                ", DOB: ",
                                patient.dob))),
                    React.createElement(Grid, { item: true, xs: 3, style: { alignContent: 'center', display: 'flex' } },
                        React.createElement(Button, { onClick: () => setIsShowingConsentLogs(!isShowingConsentLogs), size: 'small', variant: 'contained', style: {
                                backgroundColor: '#2C78EB',
                                marginLeft: 'auto',
                                height: '30px'
                            } }, isShowingConsentLogs ? 'Back to consent' : 'View consent log')))),
            React.createElement(Divider, null),
            React.createElement(DialogContent, null, isShowingConsentLogs ?
                React.createElement(ConsentLogHistoryLayout, { patient: patient, consentLogs: consentLogs })
                :
                    (React.createElement("div", { className: 'problem-list-scroll' },
                        React.createElement(CgmConsentSection, { patient: patient, active: cgmSelection, activeChanged: handleCgmActiveChanged }),
                        React.createElement(CcmConsentSection, { patient: patient, consentMethod: consentMethodCcm, consentDate: consentDateCcm, consentNotes: consentNotesCcm, optOutReason: optOutReasonCcm, optOutDate: optOutDateCcm, optOutNotes: optOutNotesCcm, onCcmDataChange: handleCcmDataChange, onCcmRequiredChecks: handleCcmRequiredChecks }),
                        React.createElement(RpmConsentSection, { patient: patient, consentMethod: consentMethod, consentDate: consentDate, consentNotes: consentNotes, optOutReason: optOutReason, optOutDate: optOutDate, optOutNotes: optOutNotes, onRpmDataChange: handleRpmDataChange, onRpmRequiredChecks: handleRpmRequiredChecks }),
                        React.createElement(Button, { disabled: !canSave, onClick: handleSaveChanges, style: { marginTop: '25px', width: '100%', marginLeft: 'auto', marginRight: 'auto', marginBottom: '10px' }, variant: "contained", color: "primary", startIcon: React.createElement(SaveOutlined, null) }, "Save Changes"))))))));
};
